<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="organization != null"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>

            <v-text-field
                disabled
                readonly
                :value="organization.organization_id"
                label="Organization Id"
                autocomplete="off"
            />

            <v-text-field
                v-model="organization.label"
                label="Organization Name"
                autocomplete="off"
            />

            <v-select
                label="Industry"
                v-model="organization.industry"
                :items="$rc.enumChoices('industry_code',false)"
            />

            <v-select
                label="Primary Time Zone"
                v-model="organization.primary_timezone"
                :items="$rc.commonTimeZones()"
            />

            <v-select
                label="Headquarter Location"
                v-model="organization.country_and_subdivision"
                :items="$rc.locationChoices()"
            />

            <v-checkbox
                style="margin-top: -5px"
                label="Archived"
                v-model="organization.is_archived"
            />

            <v-checkbox
                style="margin-top: -15px"
                label="Non-Revenue"
                v-model="is_non_revenue_account"
                v-on:change="onChangeNonRevenue"
            />

            <v-checkbox
                style="margin-top: -15px"
                label="RedChirp Promotion Prohibited"
                v-model="organization.red_chirp_promotion_prohibited"
            />

            <m-edit-tags
                label="Organization Origin (a.k.a. Promos)"
                applies_to="organization-origin"
                v-model="organization.rc_tag_ids"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            {{ok_btn_text}}
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,

            is_create_dialog: false,
            organization: null,
            is_non_revenue_account: false,
            org_origin_tags: [],
            selected_org_origins: [],
        }
    },

    methods: {

        showDialog(current_organization)
        {
            this.selected_org_origins = [];
            this.loadOrgOriginTags();
            if ( current_organization == null )
            {
                this.is_create_dialog = true;

                this.organization = {
                    'organization_id': this.$rc.uuidv4(),
                    'label': '',
                    'industry': 'uncategorized',
                    'country_and_subdivision': null,
                    'red_chirp_promotion_prohibited': false,
                    'is_revenue_account': true,
                    'is_archived': false,
                    'rc_tag_ids': [],
                };
            }
            else
            {
                this.is_create_dialog = false;
                this.organization = _.cloneDeep(current_organization);
            }

            this.dialog = true;
        },

        loadOrgOriginTags()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/rc-tags',
            
                'params' : {
                        'is_org_origin': true,
                    },
            
                'on_success': (data) => {
                        this.org_origin_tags = data.results;
                    },
            
                'on_error': 'Unable to list organization origin tags',
            });
        },

        onOk()
        {
            this.$rc.showSpinner();

            this.organization.is_revenue_account = !this.is_non_revenue_account;
            
            this.$rc.rest(
                'PUT: /api/v1/red-chirp-crm/organizations',
            
                this.organization,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.dialog = false;
                    this.$emit('input', this.organization);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to save organization');
                },
            );
        },

        onCancel()
        {
            this.dialog = false;
        },

        onChangeNonRevenue(value)
        {
            this.organization.is_revenue_account = !value;
        },

        getCurrentTimezone()
        {
            let all_zones = this.getTimezones();

            for ( let i = 0; i < all_zones.length; i++ )
            {
                if ( all_zones[i].value == this.organization.primary_timezone ) 
                    return all_zones[i];
            }

            return null;
        },

        

    },

    computed: {
        title() {
            if ( this.is_create_dialog )
            {
                return 'Create Prospective Organization';
            }

            return 'Edit Organization General Info';
        },

        ok_btn_text()
        {
            if ( this.is_create_dialog ) return 'Create';
            return 'Save';
        },

        is_valid()
        {
            if ( this.organization.label == null || this.organization.label.trim().length == 0 ) 
                return false;

            if ( this.organization.primary_timezone == null ) return false;
            if ( this.organization.industry == null ) return false;
            
            return true;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>